import { consumeProxies as TConsumeProxies } from '../index.d';


export const consumeProxies: typeof TConsumeProxies = (input, proxies) => {
  let i = 0;
  while (i < input.length) {
    const next = input.slice(i);
    for (const proxy of proxies) {
      const replace = proxy.replaceBeforeInference(next);
      if (replace && replace.replacement && replace.origin) {
        const replacement = replace.replacement;
        const newInput = input.slice(0, i) + replacement + input.slice(i + replace.origin.length);
        return consumeProxies(newInput, proxies);
      }
    }
    i++;
  }
  return input;
};
